import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Brand, PartnerType } from '../../../../models/brand.interface';
import { CompatibilityService } from '../../../../services/compatibility.service';
import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
} from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { LazyImageDirective } from '../../../../../../../../directive/lazyImage.directive';
import { NgClass } from '@angular/common';

@Component({
  selector: 'brand-item',
  styleUrls: ['./brand-item.component.scss'],
  template: `
    <div class="brand" (click)="onClick(brand)">
      <div class="brand-name">{{ brand.name }}</div>

      <!-- Change the border color from the PartnerType -->
      <div
        class="logo"
        [ngClass]="{
          'gold-partnership': brand.partnership === PartnerType.GOLD,
          'silver-partnership': brand.partnership === PartnerType.SILVER,
          'bronze-partnership': brand.partnership === PartnerType.BRONZE,
        }">
        <img [src]="brand.logo" [alt]="brand.name" />
      </div>

      @if (brand.partnership !== PartnerType.BRONZE) {
        <div
          class="partner-badge"
          [ngClass]="{
            xSmallScreen: xSmallScreen,
            smallScreen: smallScreen,
            mediumScreen: mediumScreen,
            webScreen: webScreen,
            largeScreen: largeScreen,
            xLargeScreen: xLargeScreen,
          }">
          <img
            [ngClass]="{
              xSmallScreen: xSmallScreen,
              smallScreen: smallScreen,
              mediumScreen: mediumScreen,
              webScreen: webScreen,
              largeScreen: largeScreen,
              xLargeScreen: xLargeScreen,
            }"
            [src]="
              'assets/images/partnership/badges/' +
              brand.partnership +
              '-badge-sm.svg'
            "
            alt="" />
        </div>
      }
    </div>
  `,
  standalone: true,
  imports: [NgClass, LazyImageDirective],
})
export class BrandItemComponent implements OnInit, OnDestroy {
  @Input() brand!: Brand;

  PartnerType: typeof PartnerType = PartnerType;
  subscriptions: Subscription[] = [];
  // --- Responsive Variables
  xSmallScreen: boolean;
  smallScreen: boolean;
  mediumScreen: boolean;
  webScreen: boolean;
  largeScreen: boolean;
  xLargeScreen: boolean;

  constructor(
    private compatibilityService: CompatibilityService,
    private responsive: BreakpointObserver
  ) {}

  onClick(brand: Brand): void {
    this.compatibilityService.selectBrand(brand.id);
  }

  public get logoClass(): string {
    const partnership: string =
      this.brand.partnership === PartnerType.GOLD
        ? PartnerType.GOLD
        : this.brand.partnership === PartnerType.SILVER
          ? PartnerType.SILVER
          : PartnerType.BRONZE;
    return `${partnership}-partnership`;
  }

  ngOnInit(): void {
    this.subscriptions = [
      this.responsive
        .observe(Breakpoints.XSmall)
        .subscribe((result: BreakpointState) => {
          this.xSmallScreen = result.matches;
        }),

      this.responsive
        .observe(Breakpoints.Small)
        .subscribe((result: BreakpointState) => {
          this.smallScreen = result.matches;
        }),

      this.responsive
        .observe(Breakpoints.Medium)
        .subscribe((result: BreakpointState) => {
          this.mediumScreen = result.matches;
        }),

      this.responsive
        .observe(Breakpoints.Web)
        .subscribe((result: BreakpointState) => {
          this.webScreen = result.matches;
        }),

      this.responsive
        .observe(Breakpoints.Large)
        .subscribe((result: BreakpointState) => {
          this.largeScreen = result.matches;
        }),

      this.responsive
        .observe(Breakpoints.XLarge)
        .subscribe((result: BreakpointState) => {
          this.xLargeScreen = result.matches;
        }),
    ];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((res: Subscription) => res.unsubscribe());
  }
}
